<template>
    <div class="user-inputs">
        <div class="operation">
            <h3>Operation</h3>
            <input type="radio" id="and" value="AND" v-model="operation" />
            <label for="and">AND</label>
            <input type="radio" id="or" value="OR" v-model="operation" />
            <label for="or">OR</label>
            <input type="radio" id="not" value="NOT" v-model="operation" />
            <label for="not">NOT</label>
            <input type="radio" id="xor" value="XOR" v-model="operation" />
            <label for="xor">XOR</label>
        </div>

        <div class="poly-title">
            <h3>Subject</h3>
            <span class="input-error">{{ suberror }}</span>
        </div>
        <textarea v-model="subject"></textarea>

        <div class="poly-title">
            <h3>Clipping</h3>
            <span class="input-error">{{ cliperror }}</span>
        </div>
        <textarea v-model="clipping"></textarea>

        <h3>Load Example</h3>
        <select v-model="selected_example">
            <option v-for="example in Object.keys(examples)">{{ example }}</option>
        </select>
        <input type="button" value="Randomize" v-on:click="randomize" />
    </div>
</template>

<script>
import Examples from '../examples.js'
import { mapState } from 'vuex'

import _ from 'lodash'

export default {
    name: 'user-inputs',
    data () {
        return {
            subject: '',
            clipping: '',
            examples: '',
            operation: 'AND',
            selected_example: ''
        }
    },
    mounted () {
        this.examples = Examples
        this.selected_example = 'Concentric Circles'
        this.subject = JSON.stringify(this.$store.subject)
        this.clipping = JSON.stringify(this.$store.clipping)
    },
    computed: {
        subject_validated () {
            return this.validate(this.subject)
        },
        subject_is_valid () {
            return this.subject_validated[0] === null ? false : true
        },
        suberror () {
            return this.subject_validated[1]
        },
        clipping_validated () {
            return this.validate(this.clipping)
        },
        clipping_is_valid () {
            return this.clipping_validated[0] === null ? false : true
        },
        cliperror () {
            return this.clipping_validated[1]
        }
    },
    watch: {
        selected_example () {
            this.subject = this.examples[this.selected_example].subject
            this.clipping = this.examples[this.selected_example].clipping
        },
        subject_is_valid (valid) {
            if (valid) { this.clip(this) }
        },
        clipping_validated (valid) {
            if (valid) { this.clip(this) }
        },
        operation () {
            if (this.subject_is_valid && this.clipping_is_valid) {
                this.clip(this)
            }
        }
    },
    methods: {
        validate (data) {
            // return:
            // [data (data || null), reason (if valid === null)]
            let parsed
            try {
                parsed = JSON.parse(data)
            } catch (e) {
                return [null, 'invalid JSON']
            }
            for (let poly of parsed) {
                if (poly.length % 2 !== 0) {
                    return [null, 'Odd number of points']
                }
            }
            return [parsed, '']
        },
        randomize () {
            let [min, max] = [0, 400];
            let [sub, clip] = [[], []];
            for (let i = 0; i < 50; i++) {
                sub.push(Math.floor(Math.random() * max))
            }
            for (let i = 0; i < 10; i++) {
                clip.push(Math.floor(Math.random() * max))
            }
            this.subject = JSON.stringify([sub])
            this.clipping = JSON.stringify([clip])
        },
        clip: _.debounce((that) => {
            // skip if invalid by the time this is called
            if (that.subject_validated[0] === null || that.clipping_validated[0] === null) {
                return
            }
            that.$store.dispatch('clip', {
                subject: that.subject_validated[0],
                clipping: that.clipping_validated[0],
                operation: that.operation
            })
        }, 100)
    }
}
</script>

<style>
.user-inputs {
    width: 100%;
    text-align: left;
    margin: 0 1.5rem;
    font-size: 0.8rem;
}
.user-inputs textarea {
    width: 100%;
    min-height: 4rem;
    font-size: 0.8rem;
}
.input-error {
    color: red;
    margin-left: 0.5rem;
}
.poly-title {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// UserInputs.vue?590967d6